const GET_TODAY_CENTER_TIMECARDS_REQUEST = 'GET_TODAY_CENTER_TIMECARDS_REQUEST';
const GET_TODAY_CENTER_TIMECARDS_SUCCESS = 'GET_TODAY_CENTER_TIMECARDS_SUCCESS';
const GET_TODAY_CENTER_TIMECARDS_FAILURE = 'GET_TODAY_CENTER_TIMECARDS_FAILURE';
const GET_EMPLOYEE_TIMECARDS_IN_RANGE_REQUEST = 'GET_EMPLOYEE_TIMECARDS_IN_RANGE_REQUEST';
const GET_EMPLOYEE_TIMECARDS_IN_RANGE_SUCCESS = 'GET_EMPLOYEE_TIMECARDS_IN_RANGE_SUCCESS';
const GET_EMPLOYEE_TIMECARDS_IN_RANGE_FAILURE = 'GET_EMPLOYEE_TIMECARDS_IN_RANGE_FAILURE';
const SET_EDITS_TO_TIMECARD = 'SET_EDITS_TO_TIMECARD';
const UPDATE_TIMECARDS_REQUEST = 'UPDATE_TIMECARDS_REQUEST';
const UPDATE_TIMECARDS_SUCCESS = 'UPDATE_TIMECARDS_SUCCESS';
const UPDATE_TIMECARDS_FAILURE = 'UPDATE_TIMECARDS_FAILURE';

export default {
  GET_TODAY_CENTER_TIMECARDS_REQUEST,
  GET_TODAY_CENTER_TIMECARDS_SUCCESS,
  GET_TODAY_CENTER_TIMECARDS_FAILURE,
  GET_EMPLOYEE_TIMECARDS_IN_RANGE_REQUEST,
  GET_EMPLOYEE_TIMECARDS_IN_RANGE_SUCCESS,
  GET_EMPLOYEE_TIMECARDS_IN_RANGE_FAILURE,
  SET_EDITS_TO_TIMECARD,
  UPDATE_TIMECARDS_REQUEST,
  UPDATE_TIMECARDS_SUCCESS,
  UPDATE_TIMECARDS_FAILURE
};
